export default __webpack_public_path__ + "static/media/pokedex2.1a508820.jpg";